/* Utilitaires de styles pour l'application */

/* Import des composants */
import './components/buttons.css';
import './components/circuit-breaker.css';
import './components/dynamic-select.css';
import './components/text-input-duo.css';
import './components/text-input-duo-list.css';

/* Import des thèmes */
import './themes/appsmith.css';
import './themes/dark.css';

/* Utilitaire pour appliquer un thème */
export const applyTheme = (themeName) => {
  // Supprimer tous les thèmes existants
  document.body.classList.remove('theme-appsmith', 'theme-dark');
  
  // Appliquer le nouveau thème
  if (themeName === 'dark') {
    document.body.classList.add('theme-dark');
  } else if (themeName === 'light' || themeName === 'appsmith') {
    // 'light' est un alias pour 'appsmith'
    document.body.classList.add('theme-appsmith');
  } else {
    // Thème par défaut : light (appsmith)
    document.body.classList.add('theme-appsmith');
  }
};

/* Utilitaire pour obtenir les variables CSS du thème actuel */
export const getThemeVariable = (variableName) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName);
};

/* Utilitaire pour définir une variable CSS personnalisée */
export const setThemeVariable = (variableName, value) => {
  document.documentElement.style.setProperty(variableName, value);
};
